import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import {
    DiagnosisConsultationModalConsultationNewState,
    initialDiagnosisConsultationModalConsultationNewState
} from '@/modules/diagnosisModule/views/form/modals/consultation/modal-consultation-new/diagnosis-consultation-modal-consultation-new.model'
import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { commonPersonnelService } from '@/api/services/common/personnel/common-personnel.service'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
import { DiagnosisConsultationCreateRequest } from '@/modules/diagnosisModule/services/diagnosis-consultation/diagnosis-consultation.dto'
import sessionStore from '@/session/sessionStore'
import { store } from '@/store/store'

@Component
export default class DiagnosisConsultationModalConsultationNew extends Vue {
    @Ref() readonly newConsultModal!: BModal

    @Prop({ type: Number, required: true }) readonly caseId!: number
    @Prop({ type: Number, required: true }) readonly pathologistId!: number

    @Emit('create')
    private _createConsultation(): DiagnosisConsultationCreateRequest {
        return {
            receiverPersonnelId: this.state.pathologist!.id,
            requesterObservations: this.state.observations!,
            requesterPersonnelId: sessionStore.getUserPersonnelId()!
        }
    }

    get laboratories(): CommonLaboratoryResponse[] {
        return store.state.laboratoriesConfiguration.map(laboratoryConfiguration => laboratoryConfiguration.laboratory)
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    state: DiagnosisConsultationModalConsultationNewState
    constructor() {
        super()
        this.state = initialDiagnosisConsultationModalConsultationNewState()
    }

    /// SERVICES CALLS ///

    private async _getPathologists(laboratoryId: number): Promise<CommonPersonnelResponse[]> {
        const response = await this.$_toCallUnique(
            commonPersonnelService.getPersonnelByResponsibilities(
                [CommonResponsibilityCodeEnum.PATHOLOGIST],
                laboratoryId))
        if (response) {
            return response.filter(personnel => personnel.active && personnel.id !== this.pathologistId)
        }
        return []
    }

    /// MODAL ///

    async loadPathologists(): Promise<void> {
        this.state.pathologists = []
        if (this.state.laboratory) {
            this.state.pathologists = await this._getPathologists(this.state.laboratory.labId)
        }
    }

    async show(): Promise<void> {
        this.state = initialDiagnosisConsultationModalConsultationNewState()
        this.newConsultModal.show()
    }

    hide(): void {
        this.newConsultModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            this._createConsultation() // emits an event
        }
    }
}
